export default {
  en: {
    time: {
      hour: "numeric",
      minute: "numeric",
    },
    date: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    shortDate: {
      month: "short",
      day: "numeric",
    },
    dayShort: {
      weekday: "short",
    },
    dayLong: {
      weekday: "long",
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
    },
    default: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
  },
  lv: {
    time: {
      hour: "numeric",
      minute: "numeric",
    },
    date: {
      // year: 'numeric',
      month: "short",
      day: "numeric",
    },
    shortDate: {
      month: "long",
      day: "numeric",
    },
    dayShort: {
      weekday: "short",
    },
    dayLong: {
      weekday: "long",
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
    },
    default: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
  },
};
